import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BadgesControl } from './badges-control';
import { BadgesConfig } from './badges-config';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent implements OnInit {
  @Input() entity: BadgesControl;
  @Output() badgeSelectEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onNavChange(changeEvent: NgbNavChangeEvent) {
    this.badgeSelectEvent.emit(changeEvent.nextId);
  }
}
